<mat-progress-bar *ngIf="status" mode="indeterminate"></mat-progress-bar>
